<template>
  <nav class="tabnav" aria-labelledby="submenu-heading">
    <h2 id="submenuheading" class="visually-hidden">Untermenü</h2>
    <ul role="list">
      <slot />
    </ul>
  </nav>
</template>

<style>
.tabnav {
  background-color: var(--bg-color-tabnav);
  margin-bottom: var(--spacing-sm);
  padding-top: var(--spacing-ml);
  font-size: var(--font-size-sm);

  ul {
    display: flex;
    gap: var(--spacing-xs);
    padding-inline: var(--spacing-sm);
  }

  a {
    inline-size: max-content;
    display: block;
    text-decoration: none;
    color: var(--text-color-body);
    padding-inline: var(--spacing-sm);
    padding-bottom: var(--spacing-xs);
    &.router-link-exact-active {
      color: var(--color-primary);
      text-decoration: underline;
      text-underline-offset: var(--spacing-sm);
      text-decoration-thickness: 2px;
    }
  }
}
</style>
